/**
 * DuletIA — Chatbot inteligente para Dulet International Group
 * Base de conocimiento: Brochure oficial Evolution Link
 */

(function () {
    'use strict';

    /* ─── Estado ─── */
    let isOpen = false;
    let userName = '';
    let messagesEl, inputEl, panelEl, badgeEl;

    /* ─── Utilidades ─── */
    const now = () => {
        const d = new Date();
        return d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
    };

    const lider = () => (userName ? `Líder ${userName}` : 'Líder');

    /* Convierte **negrita**, *cursiva* y saltos de línea a HTML */
    function md2html(text) {
        return text
            .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.+?)\*/g, '<em>$1</em>')
            .replace(/\n/g, '<br>');
    }

    /* ─── BASE DE CONOCIMIENTO ─── */
    const KB = [

        /* ACTIVOS */
        {
            keys: ['activo', 'activos', 'que son los activos', 'qué son los activos'],
            answer: () => `Los **Activos** en Evolution Link son el equivalente a los ingresos generados por tu desempeño dentro de tu **Cadena de Negocios**. Están diseñados para reinvertirse en tu propio negocio, permitiéndote crecer y fortalecer tu **Éxito Empresarial**. 💼\n\nSon la herramienta clave para lograr la **Auto-Sustentabilidad**: que tu negocio se mantenga y crezca sin necesidad de una inversión extra de tu parte. 😊\n\n¿Te gustaría que te explique cómo llegar más rápido a la auto-sustentabilidad?`
        },
        {
            keys: ['como pagan', 'cómo pagan', 'como se paga', 'cómo se paga', 'metodo de pago', 'método de pago', 'pagan en efectivo', 'pago en efectivo'],
            answer: () => `${lider()}, los **Activos** generados en Evolution Link no se entregan en efectivo, sino que están diseñados para **reinvertirse directamente en tu negocio**, ayudándote a potenciar el crecimiento de tu **Cadena de Negocios**. 💰\n\nAl colocarlos con tus líderes puedes recuperar tu dinero rápidamente, lo que te permite tener un **Negocio Propio**.\n\n¿Te gustaría conocer cómo utilizarlos estratégicamente para tu éxito empresarial? 😊`
        },
        {
            keys: ['cuando pagan', 'cuándo pagan', 'cuando se cobra', 'cuándo se cobra', 'cuando se liberan', 'cuándo se liberan'],
            answer: () => {
                const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
                const d = new Date();
                const mesActual = meses[d.getMonth()];
                const mesAnterior = meses[(d.getMonth() + 11) % 12];
                return `Los **Activos** se liberan mes con mes y puedes hacer uso de ellos después del **5to día hábil del mes**.\n\nRecuerda, ${lider()}, que **NO** puedes cobrar los activos del mes en curso ya que aún no se hace cierre del trabajo generado. Siempre se cobra lo del mes pasado. 📅\n\nEjemplo: El mes que transcurre es **${mesActual}**, entonces tus activos liberados son del mes de **${mesAnterior}**.`;
            }
        },

        /* FORMAS DE GANAR */
        {
            keys: ['como ganar', 'cómo ganar', 'formas de ganar', 'formas de ganar dinero', 'como funciona', 'cómo funciona', 'evolution link', 'explica el negocio', 'explicar el negocio', 'me explicas', 'me puede explicar', 'explícame'],
            answer: () => `¡Con gusto te explico, ${lider()}! 😊\n\nNuestro modelo **Evolution Link** ofrece **6 formas de ganar**:\n\n1️⃣ **Venta directa** — hasta 140% de ganancia\n2️⃣ **Plan en Cadena de Negocios** — hasta 60% en 4 niveles\n3️⃣ **Galardones de Liderazgo** — premios hasta $1,000,000\n4️⃣ **Legado Familiar** — hereda tu negocio\n5️⃣ **Sociedad Empresarial** — bloques accionarios + CEDIS\n6️⃣ **Un Auto último modelo** en comodato\n\nEn **La Academia Dulet** encontrarás la Educación Financiera y Motivación que necesitas. 🎓\n\n¿Te gustaría profundizar en alguna forma específica?`
        },
        {
            keys: ['forma 1', 'venta directa', 'primer forma', 'primera forma', 'manera 1', 'forma numero 1', 'forma número 1'],
            answer: () => `¡Claro, ${lider()}! 😊\n\nLa **Forma 1 — Venta Directa**: obtienes hasta un **140% de ganancia** sobre tu inversión inicial al comercializar **Dulet y Eucament**.\n\n📦 Ejemplo con **Dulet**:\nCosto de caja: $4,500 MXN → vendes 24 piezas a $450 c/u → total $10,800 → **utilidad: $6,300 MXN**\n\n🌿 Ejemplo con **Eucament**:\nCosto de caja: $4,500 MXN → vendes 48 piezas a $230 c/u → total $11,040 → **utilidad: $6,540 MXN**\n\nPuedes generar ingresos rápidos ayudando a tus clientes a mejorar su calidad de vida. 💪\n\n¿Te gustaría saber cómo maximizar tus ganancias?`
        },
        {
            keys: ['forma 2', 'cadena de negocios', 'plan cadena', 'segundo forma', 'segunda forma', 'manera 2', 'forma numero 2', 'forma número 2', 'como ganar con la cadena'],
            answer: () => `${lider()}, la **Forma 2 — Plan en Cadena de Negocios** te permite generar ingresos al construir y duplicar tu **Cadena de Negocios**. Por cada persona que se integre y empiece a construir su negocio, ganas un porcentaje de los activos generados en **4 niveles de profundidad**: ⚡\n\n📊 **Activos por nivel:**\n• 1er Nivel: **20%** = $900 MXN\n• 2do Nivel: **30%** = $1,350 MXN\n• 3er Nivel: **5%** = $250 MXN\n• 4to Nivel: **5%** = $250 MXN\n\nEvolution Link fomenta el Trabajo en Equipo asegurando ingresos en **crecimiento continuo**. 🚀\n\n¿Te gustaría saber cómo iniciar tu Cadena de Negocios?`
        },
        {
            keys: ['forma 3', 'galardon', 'galardones', 'galardón', 'tercer forma', 'tercera forma', 'manera 3', 'forma numero 3', 'forma número 3'],
            answer: () => `La **Forma 3 — Galardones de Liderazgo** 🏆\n\nDulet premia tu esfuerzo y el crecimiento de tu Cadena con **7 niveles de reconocimiento**:\n\n🪙 **LED Acero** — 30 cajas/mes × 3 meses → **$5,000**\n🥉 **LED Bronce** — 50 cajas/mes × 3 meses → **$10,000**\n🥈 **LED Plata** — 100 cajas/mes × 3 meses → **$25,000** + Sociedad\n🏅 **LED Platino** — 500 cajas/mes × 3 meses → **$50,000**\n🥇 **LED Oro** — 750 cajas/mes × 3 meses → **$100,000**\n💿 **LED Perla Negra** — 1,000 cajas/mes × 3 meses → **$500,000**\n💎 **LED Diamante** — 2,000 cajas/mes × 3 meses → **$1,000,000**\n\n¿Te gustaría conocer los detalles de algún galardón específico?`
        },
        {
            keys: ['forma 4', 'legado familiar', 'herencia negocio', 'heredar negocio', 'cuarta forma', 'manera 4'],
            answer: () => `La **Forma 4 — Legado Familiar** 🧑‍🧒‍🧒\n\nUna vez lograda y sostenida tu **Auto-Sustentabilidad**, Dulet International Group te permite dejar un **Legado para tu familia**, heredando tu empresa a quien tú decidas (esposa o cónyuge inscritos en primer nivel).\n\n📋 **Requisitos principales:**\n• Contar con **Auto-Sustentabilidad** activa\n• Tener inscrito al menos un integrante familiar en 1er nivel\n• El heredero debe tomar entrenamientos en **La Academia Dulet**\n• Proceso de prueba de **6 meses** ante Comité\n\n¡La gran oportunidad que cambiará sus vidas! 💫\n\n¿Te gustaría saber más sobre cómo consolidar tu Empresa Familiar?`
        },
        {
            keys: ['forma 5', 'sociedad empresarial', 'cedis', 'accionario', 'quinta forma', 'manera 5'],
            answer: () => `La **Forma 5 — Sociedad Empresarial** 🤝\n\nAl alcanzar el **Galardón LED Plata** (100 cajas × 3 meses consecutivos), Dulet International Group te integra a la **Sociedad Empresarial** con:\n\n✅ Voz y voto en la mesa de socios\n✅ **Activos** anuales por participación empresarial\n✅ Derecho a solicitar un **CEDIS** en tu localidad\n✅ **Bloques Accionarios** que se multiplican por tu participación\n\n¡Nadie te ha dado tanto con solo comprometerte! 💎\n\n¿Te gustaría saber cómo alcanzar el LED Plata más rápido?`
        },
        {
            keys: ['forma 6', 'automovil', 'automóvil', 'auto', 'carro', 'coche', 'sexta forma', 'manera 6', 'ultimo modelo', 'último modelo'],
            answer: () => `La **Forma 6 — ¡Un Automóvil último modelo!** 🚗✨\n\nUna vez lograda la **Sociedad Empresarial**, si alcanzas **250 activaciones** en tu Cadena durante **3 meses consecutivos**, Dulet International Group pone en tus manos un automóvil **último modelo en comodato**.\n\n✅ Ejemplo de éxito: Enero 250, Febrero 250, Marzo 250\n❌ Ejemplo negativo: Enero 250, Febrero 200, Marzo 250 → no cuenta, se reinicia desde el último mes con 250.\n\nLa **Academia Dulet** te apoya para alcanzar esta meta. 🎯\n\n¿Te gustaría saber cómo construir tu cadena para llegar a esta meta?`
        },

        /* GALARDONES INDIVIDUALES */
        {
            keys: ['led acero', 'acero'],
            answer: () => `🪙 **Galardón LED ACERO**\n\n• **Meta:** 30 cajas por **3 meses consecutivos**\n• **Premio:** $5,000 en **Activos**\n• Recuerda mantener **5 empresarios activos** en tu 1er nivel para que el sistema siga trabajando.\n\n¿Te gustaría saber cómo llegar al siguiente nivel — LED Bronce?`
        },
        {
            keys: ['led bronce', 'bronce'],
            answer: () => `🥉 **Galardón LED BRONCE**\n\n• **Meta:** 50 cajas por **3 meses consecutivos**\n• **Premio:** $10,000 en **Activos**\n• Mantén **5 empresarios activos** en tu 1er nivel.\n\n¿Quieres saber sobre el LED Plata y sus beneficios adicionales?`
        },
        {
            keys: ['led plata', 'plata'],
            answer: () => `🥈 **Galardón LED PLATA**\n\n• **Meta:** 100 cajas por **3 meses consecutivos**\n• **Premio:** $25,000 en **Activos** + acceso a la **Sociedad Empresarial** 🏢\n• Mantén **10 empresarios activos** en tu 1er nivel.\n\nEste es el galardón que desbloquea la Sociedad Empresarial y el CEDIS. ¡Es un hito clave! 🎯`
        },
        {
            keys: ['led platino', 'platino'],
            answer: () => `🏅 **Galardón LED PLATINO**\n\n• **Meta:** 500 cajas por **3 meses consecutivos**\n• **Premio:** $50,000 en **Activos**\n• Mantén **10 empresarios activos** en tu 1er nivel.\n\n¿Listo para aceptar el reto, ${lider()}? 💪`
        },
        {
            keys: ['led oro', 'oro'],
            answer: () => `🥇 **Galardón LED ORO**\n\n• **Meta:** 750 cajas por **3 meses consecutivos**\n• **Premio:** $100,000 en **Activos**\n• Mantén **10 empresarios activos** en tu 1er nivel.\n\n¡Cien mil pesos en activos, ${lider()}! 🌟 ¿Quieres conocer el siguiente nivel?`
        },
        {
            keys: ['led perla', 'perla negra', 'perla'],
            answer: () => `💿 **Galardón LED PERLA NEGRA**\n\n• **Meta:** 1,000 cajas por **3 meses consecutivos**\n• **Premio:** $500,000 en **Activos**\n• Mantén **20 empresarios activos** en tu 1er nivel.\n\n¡Medio millón de pesos, ${lider()}! 🚀`
        },
        {
            keys: ['led diamante', 'diamante'],
            answer: () => `💎 **Galardón LED DIAMANTE** — El nivel más alto\n\n• **Meta:** 2,000 cajas por **3 meses consecutivos**\n• **Premio:** **$1,000,000 en Activos** 🎉\n• Mantén **25 empresarios activos** en tu 1er nivel.\n\nEl fundador de Dulet International Group, **Sr. Alfredo Malfavón Sánchez**, ostenta este galardón con más de 40 años de trayectoria. ¡Toda una inspiración! 👑`
        },

        /* AUTOSUSTENTABILIDAD */
        {
            keys: ['autosustentabilidad', 'auto-sustentabilidad', 'autosustentable', 'sustentabilidad', 'como funciona el negocio', 'negocio propio'],
            answer: () => `**Auto-Sustentabilidad** — El secreto de tu negocio 🔑\n\nEs cuando tu negocio **no necesita que vuelvas a invertir dinero** porque tus **Activos** generados financian tu propia activación mensual ($4,500 MXN equivalente a una caja).\n\n📌 **Ejemplo para llegar a ella:**\nTienes 5 empresarios activos en tu 1er nivel:\n5 × $900 = **$4,500** → ¡Eso cubre exactamente tu activación mensual! 🎯\n\nEn ese momento tu negocio trabaja **solo para ti**, sin gastar de tu bolsillo.\n\n¿Te gustaría que te explique cómo integrar a tus primeros 5 empresarios?`
        },

        /* ACADEMIA DULET */
        {
            keys: ['academia', 'academia dulet', 'entrenamiento', 'capacitacion', 'capacitación', 'zoom', 'clases'],
            answer: () => `🎓 **La Academia Dulet** — Concepto de alto impacto\n\nEspacio transformacional para impulsar el crecimiento de la **Gran Familia Dulet**. Temas:\n\n1️⃣ Educación Financiera\n2️⃣ Tu Negocio Dulet\n3️⃣ Motivación\n4️⃣ Liderazgo\n5️⃣ Juntas de Oportunidad\n\n📅 **Horarios** (Hora del Centro de México):\n• **Lunes y Viernes** — 8:00 AM\n• **Martes y Miércoles** — 6:00 PM\n\n🖥️ **Zoom:**\nID: **86102918163**\nCódigo: **Dulet**\n\n¿Te gustaría recibir una invitación a La Academia? 😊`
        },

        /* INSCRIPCION / PRECIO */
        {
            keys: ['costo', 'precio', 'cuanto cuesta', 'cuánto cuesta', 'inscripcion', 'inscripción', 'como me uno', 'cómo me uno', 'como empiezo', 'cómo empiezo'],
            answer: () => `En Dulet International Group **no contamos con costo de inscripción** 🎉\n\nÚnicamente la adquisición de tu caja con un costo de **$4,500 MXN** (más gastos de envío), lo cual incluye:\n\n📦 **24 piezas de Dulet** (elige entre 4 sabores: Natural, Fresa, Vainilla o Chocolate) — o incluye Eucament\n\nEsto te integra como **Empresario Independiente** a la Gran Familia Dulet.\n¡Una sola inversión, posibilidades ilimitadas! 💼\n\n¿Te gustaría más información sobre cómo realizar tu primer pedido?`
        },

        /* PASOS PARA UNIRSE */
        {
            keys: ['como pedir', 'cómo pedir', 'como comprar', 'cómo comprar', 'pasos', 'proceso', 'como me registro', 'cómo me registro'],
            answer: () => `¡${lider()}, aquí los pasos para unirte! 🚀\n\n1️⃣ **Llena y firma tu contrato**\n2️⃣ **Realiza tu depósito:**\n   • BBVA: Cuenta 0116948480\n   • Santander: 65-50868696-8\n   • A nombre de: Dulet International Group S.A. de C.V.\n3️⃣ **Envía al Call Center por WhatsApp** (+52 3329 347741):\n   📸 Foto de tu INE (ambos lados)\n   📸 Foto de tu ficha de depósito\n   📋 Especifica tu pedido y dirección completa\n4️⃣ **Solicita tu número de guía**\n5️⃣ **Rastrea tu pedido y espera en tu domicilio** 📦\n\n¿Tienes alguna duda sobre el proceso?`
        },

        /* PRODUCTOS */
        {
            keys: ['dulet', 'producto dulet', 'que es dulet', 'qué es dulet', 'lactosuero', 'sabores'],
            answer: () => `🌿 **Dulet — Lactosuero Suizo**\n\nProducto natural de los más altos estándares de calidad internacional. Disponible en **4 sabores**:\n• 🤍 Natural\n• 🍓 Fresa\n• 🍦 Vainilla\n• 🍫 Chocolate\n\n📋 **Modo de uso:**\n• **Adultos:** 1 cuchara sopera copeteada en 250ml de agua, 3 veces al día, 20 min antes de cada comida\n• **Niños:** 1 cuchara cafetera en 250ml de agua, 3 veces al día\n\n💰 Precio público: **$450 MXN** por pieza\n\n¿Te gustaría saber sobre nuestro otro producto, Eucament?`
        },
        {
            keys: ['eucament', 'eucalipto', 'eucament spray', 'que es eucament', 'qué es eucament'],
            answer: () => `🍃 **Eucament — Esencia de Eucalipto**\n\nProducto natural de alta calidad con múltiples aplicaciones:\n\n✅ Realizar aspersiones en el área a tratar (puedes dar un ligero masaje)\n✅ Rociar en el ambiente a gusto y satisfacción\n✅ Usar a través de difusor\n\n💰 Precio público: **$230 MXN** por pieza\n📦 Caja de 48 piezas: $4,500 MXN → utilidad total: **$6,540 MXN**\n\n¿Quieres saber cómo vender Eucament para maximizar tus ganancias?`
        },
        {
            keys: ['quien puede usar', 'quién puede usar', 'para quien es', 'para quién es', 'uso del producto', 'como se toma', 'cómo se toma'],
            answer: () => `**¿Quién puede usar Dulet?** 🌿\n\nDulet puede ser utilizado por **adultos y niños**:\n\n👨 **Adultos:** 1 cuchara sopera copeteada en 250ml de agua, 3 veces al día, 20 min **antes** de cada comida.\n\n👧 **Niños:** 1 cuchara cafetera en 250ml de agua, 3 veces al día antes o después de los alimentos.\n\n🍃 **Eucament:** Realizar las aspersiones necesarias en el área a tratar. También puedes rociar en el ambiente o usar con difusor.\n\n¿Tienes alguna otra pregunta?`
        },

        /* LEGADO FAMILIAR (detallado) */
        {
            keys: ['reglas legado', 'requisitos legado', 'como heredar'],
            answer: () => `📋 **Reglas del Legado Familiar:**\n\n• Contar con **Auto-Sustentabilidad** activa\n• Inscribir al menos un familiar (cónyuge e/o hijo) en **1er nivel**\n• El heredero toma entrenamientos en **La Academia Dulet**\n• En vida: carta firmada cediendo derechos\n• En caso de fallecimiento: documentos legales pertinentes\n• Plazo máximo: **2 meses** después del fallecimiento\n• Periodo de prueba del heredero: **6 meses** ante Comité\n\n¿Tienes alguna duda adicional sobre el Legado Familiar?`
        },

        /* CONTACTO */
        {
            keys: ['whatsapp', 'telefono', 'teléfono', 'contacto', 'llamar', 'comunicar'],
            answer: () => `📞 **Datos de Contacto Dulet International Group:**\n\n📱 **Call Center WhatsApp:**\n+52 3329 347741\n\n🎓 **Academia Dulet (Zoom):**\nID: 86102918163 | Código: Dulet\n\n🌐 **Sitio Web:**\nwww.duletbio.com.mx\n\n¿En qué más puedo ayudarte, ${lider()}? 😊`
        },

        /* CÓMO INVITAR */
        {
            keys: ['como invitar', 'cómo invitar', 'reclutar', 'reclutar personas', 'invitar personas'],
            answer: () => `¡Gran pregunta, ${lider()}! Para invitar personas a tu **Cadena de Negocios**: 🤝\n\n1️⃣ **Habla desde tu experiencia:** Comparte cómo Dulet y Eucament te están ayudando a crecer.\n2️⃣ **Usa tus productos:** Los resultados hablan solos.\n3️⃣ **Presenta la Oportunidad:** Muéstrales las **6 formas de ganar** y la Libertad Financiera.\n4️⃣ **Apóyate en La Academia Dulet** para presentaciones de negocio profesionales.\n5️⃣ **Realiza seguimientos:** Atiende sus dudas y guíalos en el proceso.\n\n¿Te gustaría que te ayude a preparar tu presentación de negocio?`
        },

        /* HISTORIA */
        {
            keys: ['historia', 'cuando nace', 'cuándo nace', 'fundacion', 'fundación', 'quien fundo', 'quién fundó', 'alfredo malfavon', 'malfavón'],
            answer: () => `📖 **Historia de Dulet International Group:**\n\nDulet nació en **México en el año 2001**, ofreciendo Salud y Economía a través de dos únicos productos: **Dulet y Eucament**.\n\nEn **2017**, gracias a la visión empresarial del **Sr. Alfredo Malfavón Sánchez** (Líder de Proyecto Internacional, LED Diamante) con más de 40 años de experiencia, nace **Evolution Link** — un sistema innovador de cadenas de negocio.\n\nEn **2019**, Dulet se consolida como **Empresa Internacional**. 🌍\n\nHoy, impulsa y fortalece la Empresa Familiar: **¡Juntos Podemos Lograrlo!** 💪`
        },

        /* 5X5 AUTO-SUSTENTABILIDAD */
        {
            keys: ['5x5', 'ejemplo 5x5', 'cuanto puedo ganar', 'cuánto puedo ganar', 'ganancias'],
            answer: () => `📊 **Ejemplo de Ganancias con el sistema 5×5:**\n\nTÚ: Inversión inicial **$4,500**\n\n• 1er Nivel: 5 × $900 = **$4,500**\n• 2do Nivel: 25 × $1,350 = **$33,750**\n• 3er Nivel: 125 × $225 = **$28,125**\n• 4to Nivel: 625 × $225 = **$140,625**\n\n💰 Total: **$207,000 MXN mensuales** potenciales en tu cuenta.\n\n¡Y esto aplicando solo el sistema 5×5! Los galardones son adicionales. 🚀\n\n¿Empezamos a construir tu cadena?`
        },

        /* SALUDO / BIENVENIDA */
        {
            keys: ['hola', 'buenas', 'buenos dias', 'buenos días', 'buenas tardes', 'buenas noches', 'hi', 'hello', 'saludos'],
            answer: () => `¡Hola, ${lider()}! 👋 Bienvenido a **DuletIA**, tu asistente oficial de Dulet International Group. Estoy aquí para resolver todas tus dudas sobre nuestros productos, el sistema **Evolution Link** y las oportunidades de negocio. 😊\n\n¿Sobre qué te puedo ayudar hoy?`
        },

        /* GRACIAS */
        {
            keys: ['gracias', 'muchas gracias', 'ok gracias', 'thanks'],
            answer: () => `¡Con mucho gusto, ${lider()}! 😊 Estoy aquí para apoyarte en todo momento. Recuerda que en **La Academia Dulet** también puedes encontrar toda la información que necesitas para desarrollar tu negocio. ¡Mucho éxito! 💪🚀`
        },

        /* INTERÉS COMPUESTO */
        {
            keys: ['interes compuesto', 'interés compuesto', 'interes', 'rueda de la libertad'],
            answer: () => `💡 **El Interés Compuesto en Dulet:**\n\nEn Dulet haces **una sola inversión** (más gastos de envío). Si haces el negocio como te recomendamos, invitando a otros, comienzas a generar tu **Interés Compuesto** día a día, mes a mes.\n\nEl interés compuesto en finanzas es el interés de un capital al que se van **acumulando sus créditos o intereses para producir otros** — es el principio de la Rueda de la Libertad Financiera de Dulet. 🎢\n\n¿Te gustaría conocer el ejemplo del 5×5 para ver cuánto puedes ganar?`
        },

        /* MEGA / MACROTENDENCIAS */
        {
            keys: ['megatendencias', 'macrotendencias', 'tendencias', 'mega tendencias'],
            answer: () => `📈 **Mega y Macrotendencias**\n\nLas **Megatendencias** son fuerzas evolutivas en las Finanzas y Negocios capaces de transformar el mundo, generando evolución constante.\n\nLas **Macrotendencias** crecen de acuerdo a la globalización y tienen un largo periodo de vida.\n\nDulet International Group, a través de **Evolution Link**, te pone en manos la oportunidad de ser un **Empresario Poderoso** dentro de estas mega tendencias. 🌍\n\n¿Quieres saber cómo integrarte hoy?`
        }
    ];

    /* ─── Motor de respuestas ─── */
    function getResponse(input) {
        const q = input.toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // quita acentos para comparar
            .trim();

        for (const item of KB) {
            if (item.keys.some(k => {
                const kn = k.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                return q.includes(kn);
            })) {
                return item.answer();
            }
        }

        return `${lider()}, gracias por tu pregunta. 😊 Para información más específica sobre ese tema, te recomiendo contactar directamente con nuestro Call Center:\n\n📱 **WhatsApp:** +52 3329 347741\n🎓 **Academia Dulet:** Lunes/Viernes 8AM | Martes/Miércoles 6PM\nZoom ID: **86102918163** | Código: **Dulet**\n\n¿Hay algo más en lo que pueda ayudarte?`;
    }

    /* ─── Renderizado de mensajes ─── */
    function addMessage(text, type) {
        const msg = document.createElement('div');
        msg.className = `chat-msg ${type}`;

        const avatarEl = document.createElement('div');
        avatarEl.className = 'chat-msg-avatar';

        if (type === 'bot') {
            avatarEl.innerHTML = `<img src="images/dulet_logo.png" alt="DuletIA">`;
        } else {
            avatarEl.textContent = '👤';
        }

        const bubble = document.createElement('div');
        bubble.className = 'chat-bubble';
        bubble.innerHTML = md2html(text);

        msg.appendChild(avatarEl);
        msg.appendChild(bubble);
        messagesEl.appendChild(msg);
        messagesEl.scrollTop = messagesEl.scrollHeight;
        return msg;
    }

    function showTyping() {
        const msg = document.createElement('div');
        msg.className = 'chat-msg bot typing-indicator';
        msg.id = 'typingIndicator';
        msg.innerHTML = `
      <div class="chat-msg-avatar"><img src="images/dulet_logo.png" alt="DuletIA"></div>
      <div class="chat-bubble"><span class="typing-dot"></span><span class="typing-dot"></span><span class="typing-dot"></span></div>`;
        messagesEl.appendChild(msg);
        messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function hideTyping() {
        const t = document.getElementById('typingIndicator');
        if (t) t.remove();
    }

    function botReply(text, delay = 1000) {
        showTyping();
        setTimeout(() => {
            hideTyping();
            addMessage(text, 'bot');
        }, delay);
    }

    /* ─── Nombre del usuario ─── */
    function askName() {
        const overlay = document.createElement('div');
        overlay.className = 'name-prompt-overlay';
        overlay.id = 'namePrompt';
        overlay.innerHTML = `
      <div style="font-size:48px">👋</div>
      <h4>¡Bienvenido a DuletIA!</h4>
      <p>El asistente oficial de <strong>Dulet International Group</strong>. ¿Cómo te llamas, Líder?</p>
      <div class="name-input-row">
        <input type="text" id="nameInput" placeholder="Tu nombre..." autocomplete="given-name">
        <button id="nameSubmit">¡Listo!</button>
      </div>`;
        panelEl.style.position = 'relative';
        panelEl.appendChild(overlay);

        const nameInput = overlay.querySelector('#nameInput');
        const nameSubmit = overlay.querySelector('#nameSubmit');

        function confirmName() {
            const val = nameInput.value.trim();
            userName = val || '';
            overlay.remove();
            botReply(`¡Hola, Líder **${userName || 'bienvenido/a'}**! 🌟 Soy **DuletIA**, tu asistente de Dulet International Group. Estoy aquí para resolver todas tus dudas sobre nuestros productos y el sistema **Evolution Link**. 😊\n\n¿Sobre qué te puedo ayudar hoy?`, 400);
        }

        nameSubmit.addEventListener('click', confirmName);
        nameInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') confirmName(); });
        setTimeout(() => nameInput.focus(), 100);
    }

    /* ─── Enviar mensaje ─── */
    async function sendMessage(text) {
        const msg = (text || inputEl.value).trim();
        if (!msg) return;
        inputEl.value = '';

        addMessage(msg, 'user');

        // n8n Webhook Integration
        const webhookUrl = 'https://n8n.duletias3rver.com/webhook/website-bot'; // Path from website_bot.workflow.ts

        try {
            showTyping();
            const response = await fetch(webhookUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    message: msg,
                    name: userName || 'Líder'
                })
            });

            const data = await response.json();
            hideTyping();

            const botMsg = data.response || `Lo siento ${lider()}, tuve un problema al procesar tu solicitud.`;
            addMessage(botMsg, 'bot');

        } catch (error) {
            hideTyping();
            console.error('Error contacting n8n:', error);
            addMessage(`Hola ${lider()}, disculpa, mi conexión con el servidor central está fallando. Por favor contacta al WhatsApp: +52 3329 347741`, 'bot');
        }
    }

    /* ─── Toggle del panel ─── */
    function toggleChat() {
        isOpen = !isOpen;
        panelEl.classList.toggle('open', isOpen);

        const iconOpen = document.getElementById('chatToggleIcon');
        const iconClose = document.getElementById('chatToggleClose');
        iconOpen.style.display = isOpen ? 'none' : 'flex';
        iconClose.style.display = isOpen ? 'flex' : 'none';

        if (isOpen) {
            // Oculta badge
            if (badgeEl) badgeEl.classList.add('hidden');
            // Pide nombre si es primera vez
            if (!userName) {
                setTimeout(askName, 350);
            }
            setTimeout(() => inputEl && inputEl.focus(), 400);
        }
    }

    /* ─── Init ─── */
    function init() {
        messagesEl = document.getElementById('chatbotMessages');
        inputEl = document.getElementById('chatbotInput');
        panelEl = document.getElementById('chatbotPanel');
        badgeEl = document.getElementById('chatbotBadge');

        if (!messagesEl || !inputEl || !panelEl) return;

        // Toggle buttons
        document.getElementById('chatbotToggle').addEventListener('click', toggleChat);
        document.getElementById('chatbotMinimize').addEventListener('click', toggleChat);

        // Send button
        document.getElementById('chatbotSend').addEventListener('click', () => sendMessage());

        // Enter key
        inputEl.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
        });

        // Quick replies
        document.querySelectorAll('.quick-reply').forEach(btn => {
            btn.addEventListener('click', () => sendMessage(btn.dataset.msg));
        });

        // Auto-open after 8 seconds with a teaser if chat hasn't been opened
        setTimeout(() => {
            if (!isOpen) {
                if (badgeEl) badgeEl.classList.remove('hidden');
            }
        }, 3000);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();